import { render, staticRenderFns } from "./WorkplaceLockModal.vue?vue&type=template&id=5d4ad3d4&"
import script from "./WorkplaceLockModal.vue?vue&type=script&lang=js&"
export * from "./WorkplaceLockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports